/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "@/router";
const mutations = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex(
      item => item.url == payload.url
    );

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(
        state.navbarSearchAndPinList["pages"].data[index]
      );
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        item => item.url == payload.url
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map(i => {
      if (list.indexOf(i) > -1) downToUp = true;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    // Get Data localStorage
    // let userInfo = state.AppActiveUser;

    state.AppActiveUser = payload;
    router.push("/hospitalreports");

    // Store data in localStorage
    // localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  LOG_OUT_USER(state) {
    state.AppActiveUser = {};
  },
  //manage settings
  UPDATE_SETTING_LIST(state, payload) {
    state.settingList = payload;
  },
  UPDATE_GLOBAL_DATA(state, payload) {
    state.globalData.dateRange = payload.dateRange;
    state.globalData.activeCases = [payload.dataSets.activeCaseData];
    state.globalData.newCases = [payload.dataSets.newCaseData];
    state.globalData.totalCases = [payload.dataSets.totalCaseData];
    state.globalData.criticalCases = [payload.dataSets.criticalCaseData];
    state.globalData.recoveredCases = [payload.dataSets.recoveredCaseData];
    state.globalData.newDeaths = [payload.dataSets.newDeathData];
    state.globalData.totalDeaths = [payload.dataSets.totalDeathData];
    state.globalData.globalDataLoading = false;
  },

  UPDATE_VICTORIAN_DATA(state, payload) {
    state.victorianData = payload;
  },
  UPDATE_VICTORIAN_LIVE_DATA(state, payload) {
    state.victorianLiveData = payload;
    state.victorianLiveDataLoaded = true;
  },
  UPDATE_AUSTRALIAN_LIVE_DATA(state, payload) {
    state.australianLiveData = payload;
    state.australianLiveDataLoaded = true;
  },
  UPDATE_HOSPITAL_DATA(state, payload) {
    state.hospitalData = payload;
  },
  UPDATE_ACTIVE_HOSPITAL(state, payload) {
    state.activeHospital = payload;
  },
  UPDATE_CHART_HEIGHT(state, payload) {
    state.chartHeight = payload;
  },
  PUSH_LANCET_RSS_RESULTS(state, payload) {
    state.lancetRssResults = state.lancetRssResults.concat(payload);
  },
  PUSH_NEJM_RSS_RESULTS(state, payload) {
    state.nejmRssResults = state.nejmRssResults.concat(payload);
  },
  PUSH_JAMA_RSS_RESULTS(state, payload) {
    state.jamaRssResults = state.jamaRssResults.concat(payload);
  },
  PUSH_ERSJ_RSS_RESULTS(state, payload) {
    state.ersjRssResults = state.ersjRssResults.concat(payload);
  }
};

export default mutations;
